export default function ({ store, $sentry }) {
  if (!$sentry || !process.client) {
    return
  }

  // Function to set Sentry user context
  const setSentryUser = () => {
    let userData = null

    // Priority 1: Logged in user data from store
    if (store.state.user?.auth?.userData) {
      const authUser = store.state.user.auth.userData
      userData = {
        id: authUser.ID,
        publicId: authUser.PublicID,
        email: authUser.Email,
        username: authUser.Fullname,
        doctorType: authUser.DoctorType,
        role: store.state.user.auth.role
      }
    } else if (store.state.user?.auth?.email) {
      // Priority 2: Email from auth store (during login process)
      userData = {
        email: store.state.user.auth.email,
        role: store.state.user.auth.role
      }
    }

    if (userData) {
      $sentry.setUser(userData)
    } else {
      $sentry.setUser(null)
    }
  }

  // Set user on initial load
  setSentryUser()

  // Watch for store changes to update Sentry user
  store.watch(
    state => state.user?.auth?.userData,
    () => setSentryUser()
  )

  store.watch(
    state => state.user?.auth?.isAuth,
    () => setSentryUser()
  )

  store.watch(
    state => state.user?.auth?.email,
    () => setSentryUser()
  )
}
